import { getParsedWordProcessorValue } from "components/word-processor-field/word-processor-value.utils";

/**
 * Whether a scribe tab's rich-text value holds anything a clinician would see.
 *
 * Drives the content dot on the details tabs. These values are HTML — `soap_notes`, `summary`,
 * `custom_context`, and an audiology note's `notes` — so plain truthiness is wrong: `"<p></p>"`
 * and `"<p>&nbsp;</p>"` are truthy strings that render as nothing.
 *
 * Built on the same primitive as `isCustomContextEmpty` (`paused-edit/scribe-context.util.ts`)
 * so the Scribe Context dot cannot disagree with `ScribeContextEditor`'s own empty-state
 * banner. It also unwraps the JSON-wrapped `{html: …}` shape a TinyMCE value can take, which a
 * bare `convertHtmlToText` would read as text and dot on an empty context. That util stays in
 * its own file for the ENG-1463 worker-bundle reason documented there — this chain reaches
 * `utils/common`, which imports `file-saver`.
 */
export const hasScribeTabContent = (value?: string | null): boolean =>
  !getParsedWordProcessorValue(value ?? "").isTextEmpty;
